import React, { createContext, useContext, useState, ReactNode } from 'react'

interface User {
  id: string
  businessName: string
  email: string
  type: 'business' | 'individual'
}

interface AuthContextType {
  user: User | null
  login: (email: string, password: string) => Promise<void>
  logout: () => void
  isAuthenticated: boolean
}

const AuthContext = createContext<AuthContextType | undefined>(undefined)

export const useAuth = () => {
  const context = useContext(AuthContext)
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  return context
}

interface AuthProviderProps {
  children: ReactNode
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const [user, setUser] = useState<User | null>({
    id: 'demo-user-1',
    businessName: 'Demo Business Ltd.',
    email: 'demo@stablepay.com',
    type: 'business'
  })

  const login = async (email: string, password: string) => {
    // Mock login - in demo mode, always succeed
    setUser({
      id: 'demo-user-1',
      businessName: 'Demo Business Ltd.',
      email: email,
      type: 'business'
    })
  }

  const logout = () => {
    setUser(null)
  }

  const isAuthenticated = user !== null

  const value: AuthContextType = {
    user,
    login,
    logout,
    isAuthenticated
  }

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  )
}